"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hilloLog = hilloLog;
var styles = {
  warnLeft: "background:#ef6c00;color:white;padding:4px 2px;border-radius:5px 0 0 5px",
  tagRight: "background:#2e7d32;color:white;padding:4px 2px;border-radius:0 5px 5px 0",
  warn: "background:#ef6c00;color:white;padding:4px 2px;border-radius:5px"
};

function styleString(string) {
  for (var _len = arguments.length, style = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    style[_key - 1] = arguments[_key];
  }

  return ['%c%s', style.join(';'), string];
}

function additionalTagBuilder(tag) {
  return tag ? ["%c%s%c%s", styles.warnLeft, '[Hillo]', styles.tagRight, tag] : null;
}

function hilloLog(msg) {
  var _additionalTagBuilder;

  var addtionalTag = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var hilloString = styleString('[Hillo]', styles.warn);
  var hilloTag = (_additionalTagBuilder = additionalTagBuilder(addtionalTag)) !== null && _additionalTagBuilder !== void 0 ? _additionalTagBuilder : hilloString;

  for (var _len2 = arguments.length, rest = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    rest[_key2 - 2] = arguments[_key2];
  }

  console.log(...hilloTag, msg, ...rest);
}